export const getContentsFromTrails = trails => {
    const contents = (trails || []).reduce((acc, trail) => {
        const trailItems = (trail || {}).items
        const contentsItems = trailItems.map(item => ((item || {}).conteudos))
        return [...acc, ...contentsItems]
    }, [])

    const allContents = contents.reduce((acc, item) => [...acc, ...item], [])
    return allContents
}

export const getContentIndexById = contents => contentId => (
    (contents || []).findIndex(item => (item || {})._id === contentId)
)

export const getNextContentIdFromContents = contents => currentContentId => {
   const currentContentIndex = getContentIndexById(contents)(currentContentId)
   const nextIndex = (currentContentIndex + 1)
   return nextIndex < contents.length ? nextIndex : -1
}

export const getPrevContentIdFromContents = contents => currentContentId => {
   const currentContentIndex = getContentIndexById(contents)(currentContentId)
   const prevIndex = (currentContentIndex - 1)
   return prevIndex >= 0 ? prevIndex : -1
}